<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
		<g id="column" transform="translate(-8.5 -13.001)">
			<path
				id="Path_20134"
				data-name="Path 20134"
				d="M670.561,378.913h2a1.5,1.5,0,0,1,1.5,1.5v6a1.5,1.5,0,0,1-1.5,1.5h-2a1.5,1.5,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,1.5-1.5Z"
				transform="translate(-660.061 -365.412)"
				fill="none"
				stroke="#939393"
				stroke-width="1"
			/>
			<line id="Line_627" data-name="Line 627" x2="5" transform="translate(9 16.5)" fill="none" stroke="#939393" stroke-width="1" />
			<line id="Line_628" data-name="Line 628" x2="5" transform="translate(9 19.5)" fill="none" stroke="#939393" stroke-width="1" />
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ColumnSvg',
};
</script>
